module.exports = __webpack_public_path__ + "media/images/tests_inc_5_200x200-6bc2afea04dce51afce2ce3fecdf1e14.png";